import { Box } from "@twilio-paste/core/box";
import { Heading } from "@twilio-paste/core/heading";
import { Paragraph } from "@twilio-paste/core/paragraph";
import React from "react";
import GetStartedWhy from "../../../assets/icons/get-started-why.svg";
import { GetStartedCard, GetStartedCardIllustration, GetStartedCardLink } from "../GetStartedCard";

export const GetStarterWhy: React.FC = () => (
    <GetStartedCard>
        <Box display="flex" height="100%" flexDirection="column" justifyContent="space-between">
            <div>
                <GetStartedCardIllustration>
                    <GetStartedWhy aria-hidden="true" />
                </GetStartedCardIllustration>
                <Heading as="h2" variant="heading30">
                    Components
                </Heading>
                <Paragraph>Customize user interface by adding, replacing or removing programmable components</Paragraph>
            </div>
            <GetStartedCardLink to="/programmable-components/DynamicContentStore">Learn more</GetStartedCardLink>
        </Box>
    </GetStartedCard>
);
